import React, { useState, useRef, useEffect } from "react";
import "./InfoModal.css";
import PrimaryButton from "../PrimaryButton/PrimaryButton";

const InfoModal = ({
  isOpen,
  onClose,
  title = "",
  text = "Информация",
  actionText = "Закрыть",
  action = () => {},
  modalStyles = {},
}) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="info-modal-overlay">
      <div className="info-modal" style={{ ...modalStyles }} ref={modalRef}>
        <button className="release-notes-close-button" onClick={onClose} />
        {(title && <h1 className="info-modal-title">{title}</h1>) || null}
        <div className="info-modal-content">
          <div
            style={{
              display: "block",
              whiteSpace: "pre-wrap",
              textAlign: "center",
            }}
          >
            {text}
          </div>
        </div>
        {actionText && (
          <PrimaryButton
            text={actionText}
            onClick={action}
            style={{ marginLeft: "8px", padding: "12px 24px" }}
          />
        )}
      </div>
    </div>
  );
};

export default InfoModal;
